export const shopBuyPhrases = [
  "ваууу здесь так мНОга деньг... может ли Эби их пренять стока",
  "нАрмальна поторговали!! прихади еще",
  "у меня сТОка мног всего, ты бери бери",
  "Эби может продать лЮбую вещ!! Я у4ила многа штук",
  "вот ето да, сКОра накоплю на образаванее!",
  "зелья ваще КЛАСс!",
  "скора акция ДВА ПО ЦЕНЕ трёх, приглошаю",
  "вОТ так спасиба4киии",
  "ЙЕЕЙоооо я БОГАТАЯяя!",
  "спасибо ПОКУПКУ офорырв!1",
  "у тя ваще сКОКа деняк есть?",
  "у меНЯ ещё мног зельев",
  "ищо",
  "ЭБИ, то есть я предлогаю покупать ЧАЩе",
  "еее вУНШ пунш!",
  "да я хароШая продаВ4иха",
];

export const shopNotEnoughPhrases = [
  "ето шутка?? ХАХА очень смешно, толька у меня есть калбкулятор",
  "АХРАНААААААААААААААААААААААААААА",
  "Эби не аСУЖДАЕТ без деняг, но НЕ продаст без деняг",
  "мНЕ так нелбзя прадавать",
  "можт найДЁШ работу?? или иди к гусю Джо он БРО",
  "такккккккк щя огрЕБЕШ",
  "такс что тут у нассс ага ОБМАН",
  "ага дА атли4на, вот держите ноль зельев",
];

export const starsBuyPhrases = [
  "О-о-о, сколько золота! Может, Мэриголд прикарманит чуть-чуть?.. Шучу!",
  "Отличная сделка! Возвращайся, а то я тебя… э-э-э… очень вежливо позову!",
  "У меня тут целый сундук сокровищ! Бери, не стесняйся!",
  "Мэриголд продаст что угодно! Я даже акулам кредиты выдаю… правда, они не возвращают.",
  "Йо-хо-хо! Скоро накоплю на новый корабль… или на пару лишних зубов!",
  "Дилдаксы? Да у меня их на любой вкус!",
  "Скоро акция: 'Два дилдакса по цене трёх'! Торопись, пока я не передумала!",
  "Вот это спасибо! Скоро куплю новую саблю",
  "Спасибо за покупку! Если что-то не работает… ну, это не моя проблема!",
  "У тебя вообще есть предел денег? Или ты казначей короля?",
  "У меня монет — как акульих зубов: много, острых и иногда ядовитых!",
];

export const starsNotEnoughPhrases = [
  "Это шутка? Ха! У меня есть счёты, и сабля!",
  "А-а-а-а! Без золота? Хочешь меня разорить?",
  "Мэриголд не осуждает бедность… но и не продаёт за спасибо!",
  "Мне запрещено торговать в убыток… капитан прибьёт!",
  "Может, сначала подработаешь?",
  "Так-так-так… щас я тебя по-пиратски 'поблагодарю'!",
  "Ага, мошенничество! Уважаемо.",
  "Вот тебе ноль дилдаксов, и один покедус!",
];
